import { mapGetters, mapState, mapActions } from 'vuex'
import menus from '@/config/menus'
import Auth from '@/utils/Auth'
import vip7Img from '@/assets/images/diamond7.png'
import modalHdBgImg from '@/assets/images/modal_hd_bg.png'

export default {
    name: 'Sidebar',

    data() {
        return {
            // 显示提示
            isVisible: true,
            // 显示二维码
            isVisibleCode: false,
            // 弹框类型 1: 非VIP即将过期，2: VIP即将过期, 3: 已过期
            modalType: 0,
            expireDay: 0,
            startDate: '',
            endDate: ''
        }
    },

    computed: {
        ...mapState('common', [
            'accountDiffOptions',
            'triggerVipValidate'
        ]),
        ...mapGetters('common', [
            'activeRoute',
            'deactiveRoute',
            'userInfo'
        ])
    },

    watch: {
        triggerVipValidate: {
            handler: function (val) {
                const { iRemindDay, iRemindType, sVipStartDate, sVipEndDate } = this.userInfo.aInfoData || {}
                this.startDate = sVipStartDate
                this.endDate = sVipEndDate
                this.expireDay = iRemindDay
                this.modalType = iRemindType
                console.log(this.expireDay, this.modalType)
                if (val) {
                    this.isVisible = true
                } else {
                    this.isVisible = false
                }
            },
            immediate: true
        }
    },

    mounted() {
        this.fetchAccountDiff()
    },

    methods: {
        ...mapActions('common', [
            'fetchAccountDiff'
        ]),

        isActive(menu) {
            const { isMatch, matchReg } = this.isMenuRoute(this.activeRoute)
            const { isMatch: isLastMatch, matchReg: lastMatchReg } = this.isMenuRoute(this.deactiveRoute)
            // 在左则菜单模块下
            if (isMatch) {
                return matchReg.test(menu.path)
            } else if (isLastMatch) { // 不在左则菜单，但从左则菜单跳转过来
                return lastMatchReg.test(menu.path)
            } else { // 其它情况
                const { from } = this.$route.query
                if (from) {
                    const reg = new RegExp(`^\\${menu.path}(\\/.+)?$`)
                    if ((reg.test(menu.path) && reg.test(from)) || menu.path === `/${from}`) {
                        return true
                    }
                } else {
                    if (menu.path === '/home') {
                        return true
                    }
                }
                return false
            }
        },

        isMenuRoute(path) {
            let matchReg
            const isMatch = menus.some(menu => {
                const reg = new RegExp(`^\\${menu.path}(\\/.+)?$`)
                if (reg.test(path)) {
                    matchReg = reg
                    return true
                } else {
                    return false
                }
            })

            return {
                isMatch,
                matchReg
            }
        },

        renew() {
            this.$router.push('/main/buy')
        },

        getMenuPath(menu) {
            const query = this.$route.query
            if (this.accountDiffOptions.length === 0 && menu.path === '/contrast' && this.activeRoute === '/search') {
                if (query.from) {
                    const q = query.from[0] === '/' ? query.from : `/${query.from}`
                    if (q !== '/search' && !q.includes('account/accountDetail')) {
                        this.$store.commit('common/updateDeactiveRoute', q)
                        return {
                            path: '/search',
                            query: {
                                from: 'contrast',
                                type: 'account'
                            }
                        }
                    }
                }
                return menu.path
            } else {
                return menu.path
            }
        },
        calcMenuPath(menu) {
            if (window._hmt) {
                window._hmt.push(['_trackEvent', menu.label, 'click'])
            }
        },

        close() {
            this.isVisible = false
        },
        mouseEnterFun() {
            this.isVisibleCode = true
        },
        mouseLeaveFun() {
            this.isVisibleCode = false
        }
    },

    render() {
        return (
            <div class='yt-sidebar-container'>
                <el-scrollbar class='scrollbar-wrap'>
                    <ul class='yt-menu'>
                        {
                            menus.map((menu, index) => {
                                let res = ''
                                if (index === 3 || index === 9) {
                                    res = <div class='menu-type'>{menu.label}</div>
                                } else {
                                    res = (
                                        <li class={`yt-menu-item ${this.isActive(menu) ? 'active' : ''}`} onClick={() => this.calcMenuPath(menu)}>
                                            <router-link to={this.getMenuPath(menu)} target={menu.blank && sessionStorage.getItem('powersign') !== '1' ? '_blank' : '_self'}>
                                                {
                                                    menu.icon
                                                        ? <i class={`menu-icon iconfont ${this.isActive(menu) ? menu.iconActive : menu.icon}`} />
                                                        : <i class='menu-icon dot' />
                                                }

                                                {
                                                    (!menu.hot && !menu.new) && (
                                                        <span class={`label ${!menu.icon ? 'second-label' : ''}`}>
                                                            {menu.label}
                                                            {
                                                                (menu.path === '/contrast' && this.accountDiffOptions.length > 0 && Auth.isLogin()) && <i class='badge num'>{this.accountDiffOptions.length}</i>
                                                            }
                                                        </span>
                                                    )
                                                }

                                                {
                                                    (menu.hot || menu.new) && (
                                                        <span class={`label ${!menu.icon ? 'second-label' : ''}`}>
                                                            {menu.label}
                                                            <i class={`iconfont badge ${menu.hot ? 'iconhot hot' : ''} ${menu.new ? 'iconNEW new' : ''}`} />
                                                        </span>
                                                    )
                                                }
                                            </router-link>
                                        </li>
                                    )
                                }
                                return res
                            })
                        }
                    </ul>
                </el-scrollbar>
                {/* {
                    (this.expireDay < 3 || this.modalType === 3) && (
                        <el-dialog
                            visible={this.isVisible}
                            close-on-click-modal={false}
                            close-on-press-escape={false}
                            destroy-on-close
                            append-to-body
                            show-close={this.modalType !== 3}
                            onClose={this.close}
                            width='380px'
                            custom-class={`vipOutdatedDialog ${this.modalType === 1 ? 'bg' : ''}`}
                        >
                            <div class='dialog-content'>
                                <div class='sect-1'>
                                    {
                                        this.modalType === 1 && <el-image class='sect-bg' src={modalHdBgImg} />
                                    }

                                    <div class='sect-1_wrap'>
                                        {
                                            this.modalType === 1 && (
                                                <div class='content-1'>
                                                    <el-image src={vip7Img} />
                                                    <div class='text'>
                                                        <div class='title'>恭喜您获得{this.expireDay}天免费体验</div>
                                                        <div class='desc'>体验期：{this.startDate} - {this.endDate}</div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                        {
                                            this.modalType !== 1 && (
                                                <div class='content-2'>
                                                    {
                                                        this.modalType === 2 && <div class='title'>您的账号还有{this.expireDay}天过期</div>
                                                    }

                                                    {
                                                        this.modalType === 3 && <div class='title'>您的体验已经过期</div>
                                                    }
                                                </div>
                                            )
                                        }
                                        <div class='content-action'>
                                            {
                                                this.modalType === 1 && <el-button class='dialog-btn' size='large' type='primary' onClick={this.close}>立即体验</el-button>
                                            }

                                            {
                                                this.modalType !== 1 && <el-button class='dialog-btn' size='large' type='primary' onClick={this.renew}>立即续费</el-button>
                                            }

                                        </div>
                                    </div>
                                </div>
                                <div class='line' />
                                <div class='sect-2'>
                                    <div class='chance'>
                                        扫码<strong>额外获取</strong><span>30</span>天免费试用
                                    </div>
                                    <div class='qrcode'>
                                        <el-image src={''} />
                                    </div>
                                </div>
                            </div>
                        </el-dialog>
                    )
                } */}
            </div>
        )
    }
}
